export const maskName = (name) => {
  if (!name || name.length === 0) return "";
  if (name.length === 1) return "*";
  if (name.length === 2) return name.charAt(0) + "*";
  return name.charAt(0) + "*".repeat(name.length - 2) + name.charAt(name.length - 1);
};

export const maskPhone = (phone) => {
  if (!phone || phone.length < 8) return phone || "";
  const cleaned = phone.replace(/-/g, "");
  return `${cleaned.slice(0, 3)}-****-${cleaned.slice(-4)}`;
};

export const maskPhoneInput = (value) => {
  const cleaned = value.replace(/[^0-9]/g, "");

  if (cleaned.length <= 3) {
    return cleaned;
  }
  if (cleaned.length <= 7) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  }
  if (cleaned.length <= 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
};

export const unmaskPhone = (maskedPhone) => {
  if (!maskedPhone) return "";
  return maskedPhone.replace(/-/g, "");
};
